<template>
  <transition name="fade">
    <div class="modal">
      <div 
        class="modal--background"
        v-on:click="$emit('close')"
      />

      <div 
        class="modal--box"
        v-bind:class="{ 'modal--box-small': small }"
      >
        <div class="modal--box--content">
          <div 
            class="modal--box--content--close"
            v-on:click="$emit('close')"
          >
            <CrossIcon
              v-if="closeIcon"
              class="modal--box--content--cross-icon"
            />
          </div>
          
          <div class="modal--box--content--title">
            <slot name="title"></slot>
          </div>
          
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import CrossIcon from '../../icons/cross.vue'

  export default {
    name: 'Modal',
    components: {
      CrossIcon
    },
    props: [
      'closeIcon',
      'small'
    ]
  }
</script>

<style lang="scss">
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .25s;
  }
  .fade-enter, 
  .fade-leave-to {
    opacity: 0;
  }

  .modal {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px;
    z-index: 3;

    .table {
      margin-top: 0;
      margin-bottom: 0;
      padding: 0;
    }

    &--background {
      height: 100%;
      width: 100%;
      background-color: var(--black-opacity);
      top: 0;
      left: 0;
      position: absolute;
      z-index: 1;
    }

    &--box {
      max-height: calc(100% - 30px);
      border-radius: 3px;
      background-color: var(--white);
      overflow: scroll;
      max-width: 750px;
      padding: 30px;
      width: 100%;
      z-index: 2;
      position: absolute;

      &--content {
        position: relative;

        &--close {
          position: absolute;
          top: -15px;
          right: -15px;
          cursor: pointer;
        }

        &--title {
          padding-bottom: 25px;
        }
      }
    }
    
    &--box-small {
      max-width: 360px;
    }
  }
</style>